import apiClient from "../config/apiClient";


export const generatePaymentUrl = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    const urlSuccess = `${window.location.origin}/dshboard/payments/success`;
    const urlFailed = `${window.location.origin}/dshboard/payments/failed`;
    return await apiClient.put(`/public/portal?url=transactions/paystack/init`,{"id":data,"urlSuccess":urlSuccess,"urlFail":urlFailed}, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };

// Bulk pay several pending bills at once. The backend sums the amounts of the
// given transactionIds and returns a single Paystack authorization_url.
export const generateBulkPaymentUrl = async (patientId, transactionIds) => {
    const token = window.localStorage.getItem("token");
    const urlSuccess = `${window.location.origin}/dshboard/payments/success`;
    const urlFailed = `${window.location.origin}/dshboard/payments/failed`;
    return await apiClient.put(`/public/portal?url=transactions/paystack/init-bulk`, {
      patientId,
      transactionIds,
      urlSuccess,
      urlFail: urlFailed,
    }, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };


 export const generateWalletFundingUrl = async (amount, email, patientId) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    const urlSuccess = `${window.location.origin}/dshboard/payments/success`;
    const urlFailed = `${window.location.origin}/dshboard/payments/failed`;
    
    return await apiClient.put(`/public/portal?url=transactions/paystack/init`, {
        "amount": (amount * 100),
        "email": email,
        "currency": "NGN",
        "metadata": {
            "type": "wallet_topup",
            "amount": amount,
            "patient_id": patientId,
        },
        "urlSuccess": urlSuccess,
        "urlFail": urlFailed
    }, {
        headers: {
            Authorization: "Bearer " + token,
        },
    });
};
  

//   /public/portal?url=patient/${id}/transactions?page=1&limit=12&startDate=&endDate=&status=&service_id=&token=${token}